import { useSelector, useDispatch } from '../../../react-redux';
import { updataAgentChatUrl as handleUpdataAgentChatUrl } from '../../../reducers/agent';
import i18next from 'i18next';

const useAgentChtUrl = () => {
  const dispatch = useDispatch();
  const agentChatUrl = useSelector(state => state.getIn(['agent', 'agentChatUrl'])) || i18next.t('企业聊天链接');
  const updataAgentChatUrl = data => {
    dispatch(handleUpdataAgentChatUrl(data));
  };

  return { agentChatUrl, updataAgentChatUrl };
};

export default useAgentChtUrl;
